import apiRequest from "../../apiCall";

export const GetAllProducts = () => {
  return new Promise((resolve, reject) => {
    apiRequest("GET", "shopproductapi", null, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error("Error calling Shop API:", error);
        reject(error);
      });
  });
};

export const GetRecommendedProducts = () => {
  return new Promise((resolve, reject) => {
    apiRequest("GET", "recommended-products/", null, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.error("Error calling Shop API:", error);
        reject(error);
      });
  });
};

export const GetShopData = (ip) => {
  return new Promise((resolve, reject) => {
    apiRequest("GET", `shop/item-detail/${ip}`, null, false, false)
      .then((res) => {
       
        sessionStorage.setItem("shopApi", JSON.stringify(res));
        resolve(res);
      })
      .catch((error) => {
        console.error("Error calling Shop API:", error);
        reject(error);
      });
  });
};



const GetProductDetailsById = (id) => {
  return new Promise((resolve, reject) => {
    apiRequest("GET", `shop/product-detail/${id}`, null, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Error fetching the data", error);
        reject(error);
      });
  });
};

// function to fetch product reviews
const GetProductReviewsById = (id) => {
  return new Promise((resolve, reject) => {
    apiRequest("GET", `shop/reviews/${id}`, null, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Error fetching the data:", error);
        reject(error);
      });
  });
};

// function to post a product review
const PostProductReview = (params) => {
  return new Promise((resolve, reject) => {
    apiRequest("POST", "shop/productreview", params, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Something went wrong:", error);
        reject(error);
      });
  });
};

// function for add to cart
const AddToCart = (params) => {
  return new Promise((resolve, reject) => {
    apiRequest("POST", "shop/cart", params, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Something went wrong:", error);
        reject(error);
      });
  });
};

// function to get products from cart by user id to get the COUNT of the products in the cart
const getProductsFromCartById = (id) => {
  return new Promise((resolve, reject) => {
    apiRequest("GET", `shop/cartproduct/${id}`, null, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Something went wrong:", error);
        reject(error);
      });
  });
};

// function to get cart products data
const getCartProductsDataById = (id) => {
  return new Promise((resolve, reject) => {
    apiRequest("GET", `shop/cartproductdata/${id}`, null, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Something went wrong:", error);
        reject(error);
      });
  });
};

// delete a product from cart
const deleteProductFromCart = (params) => {
  return new Promise((resolve, reject) => {
    apiRequest("DELETE", `shop/deletecart`, params, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Something went wrong:", error);
        reject(error);
      });
  });
};

// function to update cart product quantity
const UpdateCartProductQuantity = (params) => {
  return new Promise((resolve, reject) => {
    apiRequest("POST", `shop/updatecart`, params, false, false)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log("Something went wrong:", error);
        reject(error);
      });
  });
};

export default GetAllProducts;
export {
  // GetProductById,
  GetProductDetailsById,
  GetProductReviewsById,
  PostProductReview,
  AddToCart,
  getProductsFromCartById,
  getCartProductsDataById,
  deleteProductFromCart,
  UpdateCartProductQuantity,
};
